import UpdateIcon from "@mui/icons-material/Update";
import TagIcon from "@mui/icons-material/Tag";
import SchoolIcon from "@mui/icons-material/School";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import HelpIcon from "@mui/icons-material/Help";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import PsychologyIcon from "@mui/icons-material/Psychology";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

// GROUPS: These match the ellipse colors in the diagram.
export const USER_NEEDS_GROUPS = {
  know: { label: "Know", title: "fact driven", color: "#2ad2fc" },
  do: { label: "Do", title: "action driven", color: "#6cf97b" },
  understand: { label: "Understand", title: "context driven", color: "#bb71fa" },
  feel: { label: "Feel", title: "emotion driven", color: "#ff3452" }
};

// NODE COLORS: Direct from the diagram, clockwise from top/right.
export const USER_NEEDS = [
  {
    key: "update",
    label: "Update me",
    group: "know",
    icon: <UpdateIcon />,
    color: "#2ad2fc",
    description: "Give me the essential facts and latest updates: what happened, when, where, and to whom? These are classic news articles focused on the latest events, outcomes, and key details."
  },
  {
    key: "trend",
    label: "Keep me engaged",
    group: "know",
    icon: <TagIcon />,
    color: "#13e3b6",
    description: "Show me what’s trending and what people are talking about. Help me participate in the conversation and stay in the loop with topics and discussions that matter right now."
  },
  {
    key: "help",
    label: "Help me",
    group: "do",
    icon: <HelpIcon />,
    color: "#6cf97b",
    description: "Offer practical advice or clear guidance that helps me act, solve a problem, or improve my daily life. Give me checklists, how-tos, tips, or service journalism to support my needs."
  },
  {
    key: "connect",
    label: "Connect me",
    group: "do",
    icon: <ConnectWithoutContactIcon />,
    color: "#f8ed3e",
    description: "Connect me to others and help me be part of something. Tell stories that build community, empathy, or inspire action around ideas, experiences, or events I can join."
  },
  {
    key: "inspire",
    label: "Inspire me",
    group: "feel",
    icon: <PsychologyIcon />,
    color: "#ffa028",
    description: "Leave me with a positive feeling or new motivation. Share stories of people overcoming obstacles, possible solutions, or ways to make a difference. Let me see what’s possible."
  },
  {
    key: "divert",
    label: "Divert me",
    group: "feel",
    icon: <EmojiEmotionsIcon />,
    color: "#ff3452",
    description: "Entertain or distract me from everyday life. Give me something light, fun, surprising, or simply different to take my mind off the news flow."
  },
  {
    key: "perspective",
    label: "Give me perspective",
    group: "understand",
    icon: <LightbulbIcon />,
    color: "#fa5ec5",
    description: "Help me make sense of what’s happening. Offer context, different viewpoints, expert analysis, and background so I can understand the meaning and implications of the news."
  },
  {
    key: "educate",
    label: "Educate me",
    group: "understand",
    icon: <SchoolIcon />,
    color: "#bb71fa",
    description: "Deepen my knowledge and understanding. Teach me the basics, explain complex topics, or break down how things work with guides, Q&As, or explainers."
  }
];

// For chart outlines/fills (match group ellipse colors)
export const GROUP_OUTLINES = {
  know: "#2ad2fc99",
  do: "#6cf97b99",
  understand: "#bb71fa99",
  feel: "#ff345299"
};
export const GROUP_FILL = {
  know: "#e6fafd",
  do: "#ecfff2",
  understand: "#f5edfc",
  feel: "#ffeaea"
};

// MODEL ARRAYS
export const USER_NEEDS_MODELS = {
  news: [
    USER_NEEDS.find(n => n.key === "update"),
    USER_NEEDS.find(n => n.key === "educate"),
    USER_NEEDS.find(n => n.key === "help"),
    USER_NEEDS.find(n => n.key === "divert"),
  ],
  standard: USER_NEEDS
};
